// assets/stock-rules.js.liquid
(function () {
  function tokenCode(token) {
    const t = String(token || "").toLowerCase();
    const beforeX = t.split("x")[0];
    const match = beforeX.match(/^[a-z0-9._]+/);
    return match ? match[0] : "";
  }

  function skuHasCode(sku, code) {
    const tokens = String(sku || "").toLowerCase().split("-");
    const key = String(code || "").toLowerCase();
    return tokens.some(t => tokenCode(t) === key);
  }

const stockRules = window.AppleShelvingStockRules || {};

const rules =
  stockRules && Array.isArray(stockRules.rules)
    ? stockRules.rules
    : [];

  // ✅ NEW: return per-store statuses (so card-grid can aggregate QLD properly)
  function deriveMiniStatusForSku(sku) {
    const state = {
      stores: {
        stock_slacks_creek: { status: "instock" },
        stock_nerang:       { status: "instock" },
        stock_caboolture:   { status: "instock" },
        stock_fairfield:    { status: "instock" },
      }
    };

    if (!sku) return state;

    const updatedTargets = new Set();

    for (const rule of rules) {
      const matches = Array.isArray(rule.match)
        ? rule.match.some(code => skuHasCode(sku, code))
        : skuHasCode(sku, rule.match);

      if (!matches) continue;

      for (const [id, value] of Object.entries(rule.updates || {})) {
        if (updatedTargets.has(id)) continue;
        updatedTargets.add(id);

        const status = (value && value.status) ? value.status : "instock";

        // expand group update
        if (id === "stock_QLD") {
          state.stores.stock_slacks_creek.status = status;
          state.stores.stock_nerang.status = status;
          state.stores.stock_caboolture.status = status;
          continue;
        }

        // direct store update
        if (state.stores[id]) {
          state.stores[id].status = status;
        }
      }
    }

    return state;
  }

  window.AppleShelvingStock = {
    rules,
    tokenCode,
    skuHasCode,
    deriveMiniStatusForSku
  };
})();